<!--<c-header class="mb-4 d-print-none" position="sticky">-->
<ng-container>
  <c-container [fluid]="true" class="px-4">
    <button
      [cSidebarToggle]="sidebarId"
      cHeaderToggler
      class="btn d-lg-none pe-3"
      toggle="visible"
      style="margin-inline-start: -14px;color: white;"
    >
      <svg cIcon name="cilMenu" size="lg"></svg>
    </button>
    <!-- <form cForm class="d-none d-sm-flex">
      <c-input-group>
        <span cInputGroupText id="search-addon" class="bg-body-secondary border-0 px-1">
          <svg cIcon name="cilSearch" size="lg" class="my-1 mx-2 text-body-secondary"></svg>
        </span>
        <input cFormControl
               placeholder="Search..."
               aria-label="Search"
               aria-describedby="search-addon"
               class="bg-body-secondary border-0"
        />
      </c-input-group>
    </form> -->
    <c-header-nav class="d-none d-md-flex ms-auto ">
    </c-header-nav>

    <c-header-nav class="ms-auto ms-md-0">
      <div class="nav-item py-1">
        <div class="vr h-100 mx-2 text-body text-opacity-75" style="color: white !important;"></div>
      </div>
      <ng-container *ngTemplateOutlet="themeDropdown" />
      <div class="nav-item py-1">
        <div class="vr h-100 mx-2 text-body text-opacity-75" style="color: white !important;"></div>
      </div>
    </c-header-nav>

    <c-header-nav class="ms-0">
      <ng-container *ngTemplateOutlet="userDropdown" />
    </c-header-nav>
  </c-container>
</ng-container>
<!--</c-header>-->

<ng-template #userDropdown>
  <c-dropdown alignment="end" variant="nav-item">
    <button [caret]="false" cDropdownToggle style="color: white;" cTooltip="Mi cuenta" cTooltipPlacement="bottom">
      <svg cIcon name="cilUser" size="lg"></svg>
    </button>
    <div cDropdownMenu>
      <a cDropdownItem [routerLink]="['/mi-cuenta']" class="d-flex align-items-center">
        <svg cIcon class="me-2" name="cilSettings" size="sm"></svg>
        Mi cuenta
      </a>
      <hr cDropdownDivider />
      <button cDropdownItem (click)="showLogoutModal()" class="d-flex align-items-center text-danger">
        <svg cIcon class="me-2" name="cilAccountLogout" size="sm"></svg>
        Cerrar sesión
      </button>
    </div>
  </c-dropdown>
</ng-template>

<ng-template #themeDropdown>
  <c-dropdown alignment="end" variant="nav-item">
    <button [caret]="false" cDropdownToggle style="color: white;">
      @switch (colorMode()) {
        @case ("dark") {
          <svg cIcon name="cilMoon" size="lg"></svg>
        }
        @case ("auto") {
          <svg cIcon name="cilContrast" size="lg"></svg>
        }
        @default {
          <svg cIcon name="cilSun" size="lg"></svg>
        }
      }
    </button>
    <div cDropdownMenu>
      <button
        (click)="colorMode.set('light')"
        [active]="colorMode()==='light'"
        [routerLink]="[]"
        cDropdownItem
        class="d-flex align-items-center"
      >
        <svg cIcon class="me-2" name="cilSun" size="lg"></svg>
        Light
      </button>
      <button
        (click)="colorMode.set('dark')"
        [active]="colorMode()==='dark'"
        [routerLink]="[]"
        cDropdownItem
        class="d-flex align-items-center"
      >
        <svg cIcon class="me-2" name="cilMoon" size="lg"></svg>
        Dark
      </button>
      <button
        (click)="colorMode.set('auto')"
        [active]="colorMode()==='auto'"
        [routerLink]="[]"
        cDropdownItem
        class="d-flex align-items-center"
      >
        <svg cIcon class="me-2" name="cilContrast" size="lg"></svg>
        Auto
      </button>
    </div>
  </c-dropdown>
</ng-template>
